/*
 * @Author: your name
 * @Date: 2021-01-19 22:22:46
 * @LastEditTime: 2021-02-26 11:38:27
 * @LastEditors: Please set LastEditors
 * @Description: 帮助文档
 * @FilePath: \CJYX_DouYin\src\pages\Home\DY_components\DYAnnouncement\index.tsx
 */
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Servlets } from '@/service';
import moment from 'moment';
import { Loading } from '@alifd/next';

const DYAnnouncement = () => {
  const [helpList, setHelpList] = useState([]); // 存放重要信息数据
  const [loadingVisible, setLoadingVisible] = useState(false);
  const getHelpList = () => { // 调后端接口获取重要信息的数据
    Servlets('getHelpList', {}).then((res) => {
      // console.log(res.data)
      if (res.success) {
        setHelpList(res.data);
      }
      setLoadingVisible(false);
    });
  };
  const goHelp = (val) => {
    window.open(val);
  };
  useEffect(() => {
    getHelpList();
  }, []);
  return (
    <div className={styles.getHelpBox} style={{ marginBottom: 20 }}>
      <Loading visible={loadingVisible}>
        <div className={styles.boxTitle}>帮助中心</div>
        <div style={{ padding: '40px' }}>
          <ul className={styles.listSize}>
            {
              helpList.map((value, index) => {
                return (
                  <li className={styles.listItem} key={index}>
                    <div className={styles.circle} />
                    <div className={styles.listContent}>
                      <div
                        className={styles.listContentLeft}
                        onClick={() => goHelp(value.linkAddress)}
                      >{value.title}
                      </div>
                      <div
                        className={styles.listContentRight}
                      >{moment(value.releaseTime).format('YYYY-MM-DD')}
                      </div>
                    </div>
                  </li>
                );
              })
            }
          </ul>
        </div>
      </Loading>
    </div>
  );
};

export default DYAnnouncement;
